import {createReducer} from "redux-act";
import {fetchPlayersSuccess, fetchSquadsSuccess} from "modules/actions";
import {IJSONReducer, IPlayer, IReducerAction, ISquad} from "modules/types";

const initialState: IJSONReducer = {
	players: [],
	squads: [],
};
type IJSONReducerPayload<TP = null> = IReducerAction<IJSONReducer, TP>;

const onFetchPlayersSuccess: IJSONReducerPayload<IPlayer[]> = (state, payload) => ({
	...state,
	players: payload,
});

const onFetchSquadsSuccess: IJSONReducerPayload<ISquad[]> = (state, payload) => ({
	...state,
	squads: payload,
});

export const JSON = createReducer({}, initialState)
	.on(fetchPlayersSuccess, onFetchPlayersSuccess)
	.on(fetchSquadsSuccess, onFetchSquadsSuccess);
